import { useMemo } from 'react';

import { AnnotationsTrackConfig } from '../types/annotations-track-props.js';
import { processAnnotationTracksData } from '../utils/process-annotation-tracks-data.js';

/**
 *
 * @param tracks -
 * @param domain -
 * @returns
 */
export const useGroupedAnnotationsData = (
  tracks: AnnotationsTrackConfig[],
  domain?: Date[] | number[],
) =>
  useMemo(() => {
    return tracks.map((track, index) => ({
      markers: processAnnotationTracksData(track, index, domain),
      label: track.label,
      hidden: track.hidden,
    }));
  }, [tracks]);
